import React from "react";

const TemplateList = ({ templates, type, selected, setSelected }) => {
  return (
    <div className="flex flex-col gap-2">
      {templates?.map(
        (t) =>
          !t.newUser &&
          !t.resetPassword && (
            <div
              key={t._id}
              onClick={() => setSelected(t)}
              className={`p-3 rounded-lg cursor-pointer border dark:border-gray-700
            ${
              selected?._id === t._id
                ? "bg-blue-100 dark:bg-blue-900"
                : "bg-white dark:bg-gray-800"
            }`}
            >
              <p className="font-semibold">{t.name}</p>

              {type === "email" && (
                <div className="mt-1">
                  {t.newUser && (
                    <span className="text-xs px-2 py-1 bg-green-600 text-white rounded-full mr-2">
                      newUser
                    </span>
                  )}
                  {t.resetPassword && (
                    <span className="text-xs px-2 py-1 bg-red-600 text-white rounded-full">
                      resetPassword
                    </span>
                  )}
                </div>
              )}
            </div>
          )
      )}
    </div>
  );
};

export default TemplateList;
